<!--TODO FIX classes buggish behaviour-->
<mat-form-field [ngClass]="classes" class="fill override-hide-placeholder">
  @if (label) {
    <mat-label> {{label}}</mat-label>
  }
  <mat-select (openedChange)="openedChange($event)"
    (selectionChange)="emitSelected()"
    [formControl]="selectFormControl"
    placeholder="(+{{numberSelected || (selectedValues && selectedValues.length)}} selected)"
    panelClass="select-search-dropdown-panel with-search"
    [compareWith]="compareItems"
    multiple>

    @if (selectedValues?.length > 0) {
      <mat-select-trigger>
        <span class="additional-selection">
          (+{{numberSelected || selectedValues.length}} selected)
        </span>
      </mat-select-trigger>
    }

    <div class="select-container">
      <div class="row search">
        <mat-checkbox
          (change)="selectAll()"
          [(ngModel)]="select_all"
          [matTooltip]="select_all? 'Clear all (applies to current filter)': 'Select all (applies to current filter)'"
          style="margin-right:10px;margin-left:10px;flex-grow:0;">
        </mat-checkbox>
        <mat-form-field class="no-label">
          <input #search autocomplete="off" matInput
            (keydown.space)="$event.stopPropagation()" [formControl]="searchTextboxControl">
        </mat-form-field>

        <div>
          <i class="fa fa-times fa-2x" matTooltip="Clear search" matSuffix
            aria-label="Clear"
            (click)="clearSearch()">
          </i>
        </div>
      </div>
      @if (filteredOptions && filteredOptions.length == 0) {
        <mat-optgroup>
          <div>No results found!</div>
        </mat-optgroup>
      }

      @for (option of filteredOptions; track option) {
        <mat-option (onSelectionChange)="selectionChange($event)"
          [class.with-account-row]="option.attributes?.account_name"
          [title]="description_map[option.id]"
          [value]="option"
          style="width: 100%; padding-right: 8px;">
          <span class="select-item-name"
            style="flex: 20 1 auto; overflow-x: hidden; text-overflow: ellipsis;">
          {{description_map[option.id]}}</span>
          @if (option.attributes?.account_name) {
            <span
              class="account-name select-item-account-name"
            style="padding-right: 8px; flex: 0 1 auto;">{{option.attributes.account_name.trim()}}</span>
          }
        </mat-option>
      }

    </div>
  </mat-select>
</mat-form-field>

<!--ellipsis menu-->
@if (selectedValues?.length > 0) {
  <div class="select-many-search-selection">
    <i class="fa fa-ellipsis-h" [matMenuTriggerFor]="menu"></i>
    <mat-menu #menu="matMenu" class="current-selection-menu">
      <div class="current-selection">
        <label style="font-weight:bold;">Currently selected items:</label>
        @for (item of selectedValues; track item.id) {
          <ul>
            <li>
              <span [dblClickCopy]="item?.attributes?.name || stringFunction(item)">{{stringFunction(item)}}</span>
              @if (item?.attributes?.account_name) {
                <span>{{': ' + item.attributes.account_name.trim()}}</span>
              }
            </li>
            <!--        <li [innerHTML]="stringFunction(item)"></li>-->
          </ul>
        }
      </div>
    </mat-menu>
  </div>
}

<!-- Copyright 2018 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license -->
